import { DateTime } from "luxon";

/**
 * Creates human readable "last updated" time string
 */
export function lastUpdated(time: string) {
	return DateTime.fromISO(time).setLocale("en-US").toFormat("h:mm a, LLL dd");
}
